import { render, staticRenderFns } from "./CII.vue?vue&type=template&id=6723dd4a&scoped=true&"
import script from "./CII.vue?vue&type=script&lang=ts&"
export * from "./CII.vue?vue&type=script&lang=ts&"
import style0 from "./CII.vue?vue&type=style&index=0&id=6723dd4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6723dd4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbar,VToolbarTitle})
